import React from 'react'
import SinglePage from '../../views/SinglePage'

import { getWpPrivacypage } from '../../data/privacy'

export default function PrivacyPolicy (props) {
  const fullArticle = props.wp.page

  return (
    <React.Fragment>
      <SinglePage
        title={fullArticle.title.rendered.replace(/&#038;/g, '&')}
        slug={fullArticle.slug}
        body={fullArticle.excerpt.rendered}
        content={fullArticle.content.rendered}
      />
    </React.Fragment>
  );
}

export async function getStaticProps ({ preview = false }) {
  const wp = {
    ...(await getWpPrivacypage())
  }

  return {
    props: {
      wp
    }
  }
}
